import React, { Component } from 'react';
import styled from 'styled-components';

import LoadingSpinner from './LoadingSpinner';

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

const WrappedComponentParent = styled.div`
  background-color: ${({ theme }) => theme.V2.colors.overlay};
  opacity: 0.2;
`;

export const LOADING_ID = 'splash-loader-loading';

const withSplashLoader = (propName: string, size: ?string) => (WrappedComponent) => {
  return class HOC extends Component {
    isLoading(prop) {
      return (
        prop === null ||
        prop === undefined ||
        (typeof prop === 'boolean' && prop === true) ||
        (prop.hasOwnProperty('length') && prop.length === 0) ||
        (prop.constructor === Object && Object.keys(prop).length === 0)
      );
    }

    render() {
      if (!this.isLoading(this.props[propName])) {
        return <WrappedComponent {...this.props} />;
      }

      return (
        <Wrapper>
          <LoadingSpinner
            id={LOADING_ID}
            size={size || 'medium'}
            wrapperStyle={{ position: 'absolute' }}
          />
          <WrappedComponentParent>
            <WrappedComponent {...this.props} />
          </WrappedComponentParent>
        </Wrapper>
      );
    }
  };
};

export default withSplashLoader;



// WEBPACK FOOTER //
// ./src/common/components/withSplashLoader.js